import { render, staticRenderFns } from "./special-offers-filter.vue?vue&type=template&id=18554b1c"
import script from "./special-offers-filter.vue?vue&type=script&lang=js"
export * from "./special-offers-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports